module.exports = __webpack_public_path__ + "static/media/Login_Backgroud.d7a6119c.png";